/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-comment-textnodes */
import PeopleWidgetWithOutHolo from 'Components/common/components/PeopleWidgetWithOutHolo';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { PersonalityTypes } from 'Types/PersonTypes';
import { COMPANY_NEWS_ROUTE, PERSONALITY_INSIGHTS_ROUTE } from 'Utils/Constants';
import { backgroundColorParsing } from 'Utils/UtilityFunctions';
import {
  maxWidth,
  primaryColor, retina, secondaryFont, wMBold, wMedium,
} from 'Utils/utilsStyle';

const Profile = styled.div`
    display: flex;
    align-items: center;
  .title-wrapper {
    margin-left: 13px;
  }
  .title {
   color: #000000;
   font-family: ${secondaryFont};
   font-weight: ${wMBold};
   line-height: 24px;
   font-size: 20px;
   letter-spacing: -0.42px;
   margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
    }
  }
  .title:hover {
    cursor: pointer;
  }
  .add-btn {
   font-size: 9px;
   font-weight: ${wMedium};
   line-height: 15px;
   letter-spacing: -0.23px;
   color: #fff;
   border-radius: 12px;
   background-color: ${primaryColor}; 
   padding: 0px 8px;
   margin-top: 0px;
   cursor: pointer;
   display: inline-block;
  }
  .subscribed {
    display: none;
  }
`;

type Props = {
  wrapperColor: PersonalityTypes[],
  image: string,
  persona: string,
  personId: number,
  personType: string,
  companyId: number,
  title: string,
  actionAddBtn: () => void,
  subscribed: boolean;
  openInNewTab?: boolean;
  imageClassName?: string,
} | typeof defaultProps;

const defaultProps = {
  wrapperColor: [],
  image: '',
  persona: '',
  personId: 0,
  companyId: 0,
  title: '',
  actionAddBtn() { },
  subscribed: false,
  openInNewTab: false,
  personType: '',
  imageClassName: '',
};

const EngagementProfileWidget = function EngagementProfileWidget(props: Props) {
  const {
    wrapperColor, image, persona, personId, personType,
    title, companyId, actionAddBtn, subscribed,
    openInNewTab, imageClassName,
  } = props;
  const navigate = useNavigate();
  const onClickNameHandler = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    let url = '';
    if (personId) url = `${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${personType}`;
    else if (companyId) url = `${COMPANY_NEWS_ROUTE}${companyId}`;
    if (url?.length) {
      if (openInNewTab) {
        window.open(url, '_blank');
      } else navigate(url);
    }
  };
  return (
    <Profile>
      <PeopleWidgetWithOutHolo
        diameter="54px"
        diameterSm="54px"
        diameterXsm="54px"
        ringPadding="2px"
        ringPaddingSm="2px"
        margin="4px 0px"
        wrapperColor={backgroundColorParsing(wrapperColor)}
        logo={image}
        persona={persona}
        personId={personId}
        companyId={companyId}
        openInNewTab={openInNewTab}
        imageClassName={imageClassName}
      />
      <div className="title-wrapper">
        <div onClick={onClickNameHandler}>
          <h6 className="title text-truncate-one-line">{title}</h6>
        </div>
        <span
          className={`add-btn ${subscribed ? 'subscribed' : ''}`}
          onClick={actionAddBtn}
          tabIndex={0}
          onKeyPress={actionAddBtn}
          role="button"
          aria-label={personId ? 'Add to Network' : 'Add to Accounts'}
        >
          {personId ? 'Add to Network' : 'Add to Accounts'}
        </span>
      </div>
    </Profile>
  );
};

EngagementProfileWidget.defaultProps = defaultProps;
export default EngagementProfileWidget;
